import { render } from "./AddCoupons.vue?vue&type=template&id=911f3062"
import script from "./AddCoupons.vue?vue&type=script&lang=js"
export * from "./AddCoupons.vue?vue&type=script&lang=js"

import "./AddCoupons.vue?vue&type=style&index=0&id=911f3062&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__